const augmentation = {
  // 共通
  "augmentation-title": "データ拡張",
  "augmentation-coming-soon": "準備中です",

  // 因果グラフエリア
  "augmentation-fitting": "フィッティング",
  "augmentation-fitting-in-progress": "フィッティング中...",
  "augmentation-load-model": "既存モデル読み込み",
  "augmentation-load-graph": "既存グラフ読み込み",

  // 生成履歴モーダル
  "augmentation-history-button": "今月の生成履歴",
  "augmentation-history-title": "履歴",
  "augmentation-history-model": "モデル名",
  "augmentation-history-datapoints": "データポイント数",
  "augmentation-history-cost": "金額(税込)",
  "augmentation-history-started": "生成開始日時",
  "augmentation-history-finished": "生成完了日時",
  "augmentation-history-download": "CSVダウンロード",
  "augmentation-history-download-button": "ダウンロード",
  "augmentation-history-close": "閉じる",
  "augmentation-history-empty": "今月の生成履歴はありません",

  // データ拡張設定エリア
  "augmentation-settings-title": "データ拡張設定",
  "augmentation-generation-mode": "生成モード",
  "augmentation-mode-normal": "通常",
  "augmentation-mode-timeseries": "時系列",
  // 時系列モード
  "augmentation-ts-num-series": "生成系列数",
  "augmentation-ts-cycle": "サイクル単位",
  "augmentation-ts-granularity": "生成粒度",
  "augmentation-ts-start": "開始日",
  "augmentation-ts-end": "終了日",
  "augmentation-ts-time-points": "時点数",
  "augmentation-cycle-none": "なし",
  "augmentation-cycle-year": "年",
  "augmentation-cycle-month": "月",
  "augmentation-cycle-week": "週",
  "augmentation-granularity-date": "日",
  "augmentation-granularity-week": "週",
  "augmentation-granularity-month": "月",
  // 生成範囲設定
  "augmentation-range-title": "生成範囲設定",
  "augmentation-range-min": "最小値",
  "augmentation-range-max": "最大値",
  "augmentation-range-categorical": "カテゴリ変数につき指定不可",
  "augmentation-seed-data": "シードデータ",
  "augmentation-augmented-rows": "拡張後行数指定",
  "augmentation-input": "入力する",
  "augmentation-augmented-data": "拡張後データ",
  "augmentation-rows": "行数",
  "augmentation-columns": "列数",
  "augmentation-data-points": "データポイント数",
  "augmentation-charge": "料金",
  "augmentation-charge-tax": "（税込）",
  "augmentation-charge-cumulative": "{{ym}}累計",
  "augmentation-generate": "データ生成",
  "augmentation-reset": "リセット",
  "augmentation-generating": "生成中...",
  "augmentation-generate-success": "データ生成が完了しました。",
  "augmentation-generate-error": "データ生成に失敗しました。",

  // 結果確認エリア
  "augmentation-download": "ダウンロード",
  "augmentation-dist-compare": "元データとの分布比較 (KL/JSダイバージェンス)",
  "augmentation-corr-compare": "各変数間相関比較",
  "augmentation-kl-divergence": "KLダイバージェンス",
  "augmentation-js-divergence": "JSダイバージェンス",
  // 結果サマリー
  "augmentation-summary-source-rows": "元データ数",
  "augmentation-summary-columns": "カラム数",
  "augmentation-summary-generated-rows": "生成データ数",
  "augmentation-legend-seed": "シードデータ",
  "augmentation-legend-augmented": "拡張データ",
  "augmentation-corr-matrix-seed": "相関行列ヒートマップ（シードデータ）",
  "augmentation-corr-matrix-generated": "相関行列ヒートマップ（拡張データ）",
  "augmentation-corr-max-pair": "相関差が最大のペア",
};

export default augmentation;
